const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://dashboard.alnasrforging.com/api';

export default API_BASE_URL;
